var map = {
	"./365.png": 56996,
	"./3SING.png": 8606,
	"./9wicket.png": 7204,
	"./AE.png": 73592,
	"./AEcricEX.png": 61059,
	"./AG.png": 37290,
	"./AP.png": 7797,
	"./BBIN.png": 14147,
	"./BG.png": 75103,
	"./BIG.png": 69018,
	"./BNG.png": 3171,
	"./BT.png": 28852,
	"./BTI.png": 30175,
	"./Baison.png": 92898,
	"./Beterlive.png": 57526,
	"./CG.png": 81268,
	"./CMD.png": 98616,
	"./CQ9.png": 32137,
	"./CROWN.png": 8417,
	"./DB.png": 14980,
	"./DBLIVE.png": 50526,
	"./DG.png": 24713,
	"./DS88.png": 77373,
	"./Dragoon.png": 85426,
	"./ELK.png": 29018,
	"./EVO.png": 32096,
	"./Evoplay.png": 4166,
	"./Ezugi.png": 55450,
	"./FA.png": 80069,
	"./FB.png": 61294,
	"./FUN.png": 65435,
	"./Fantasma.png": 35949,
	"./FunTa.png": 77854,
	"./GW.png": 30840,
	"./GoodFortune.png": 21270,
	"./Habanero.png": 374,
	"./Hacksaw.png": 6838,
	"./IA.png": 30116,
	"./IM.png": 2504,
	"./JDB.png": 35476,
	"./JILI.png": 10260,
	"./JOKER.png": 83409,
	"./KA.png": 20106,
	"./KM.png": 15494,
	"./KX.png": 34587,
	"./KY.png": 69234,
	"./LEG.png": 14084,
	"./LOTTERY.png": 92083,
	"./Lucky.png": 20164,
	"./MP.png": 37129,
	"./Manna.png": 45299,
	"./Micro.png": 66592,
	"./NLC.png": 68033,
	"./NW.png": 43755,
	"./NetEnt.png": 87970,
	"./PANDA.png": 55736,
	"./PG.png": 741,
	"./POLY.png": 70416,
	"./PP.png": 77050,
	"./PS.png": 85361,
	"./PUSH.png": 87278,
	"./Play.png": 75896,
	"./Playtech.png": 10580,
	"./QQKENO.png": 65885,
	"./QQThai.png": 76210,
	"./RICH88.png": 9820,
	"./RSG.png": 17036,
	"./Redtiger.png": 1924,
	"./Relax.png": 32978,
	"./SA.png": 17618,
	"./SABA.png": 61705,
	"./SBO.png": 18858,
	"./SPORTS.png": 59283,
	"./SPRIBE.png": 50843,
	"./SV128.png": 31994,
	"./SV388.png": 45994,
	"./Slotmill.png": 64724,
	"./Spade.png": 10035,
	"./T1.png": 59551,
	"./TADA.png": 55210,
	"./TCG.png": 38950,
	"./TP.png": 60918,
	"./TPF.png": 66594,
	"./Thunderkick.png": 71672,
	"./UG.png": 61870,
	"./V8.png": 57108,
	"./VDD.png": 73966,
	"./V_.png": 84587,
	"./WE.png": 43530,
	"./WG.png": 36632,
	"./WL.png": 37003,
	"./WM.png": 15874,
	"./WS168.png": 82213,
	"./Wazdan.png": 17405,
	"./XGAME.png": 586,
	"./YESBINGO.png": 59632,
	"./YGG.png": 48295,
	"./YGR.png": 96202,
	"./ZZ.png": 27282
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84569;